<script setup lang="ts">
import vReveal from "@/application/directives/vReveal";

const features = [
  {
    icon: "$clipboardList",
    color: "primary",
    title: "Taken & categorieën",
    text: "Bardienst, EHBO, scheidsrechters, onderhoud, kantine, vervoer - richt categorieën in die passen bij jouw club.",
  },
  {
    icon: "$users",
    color: "accent-blue",
    title: "Leden melden zichzelf aan",
    text: "Geen rondbelrondje meer: leden zien welke taken openstaan en melden zich met één klik aan.",
  },
  {
    icon: "$mailCheck",
    color: "accent-green",
    title: "Automatische bevestiging",
    text: "Elke aanmelding, indeling en afmelding gaat automatisch per mail - in de huisstijl van je club.",
  },
  {
    icon: "$banknote",
    color: "accent-orange",
    title: "Vrijwilligersverplichting & afkoop",
    text: "Werkt jouw club met verplichte vrijwilligersuren? Leg vrijstellingen en afkoop per lid vast.",
  },
  {
    icon: "$calendar",
    color: "accent-pink",
    title: "Overzicht per seizoen",
    text: "Volg per periode hoeveel uur elk lid heeft gedraaid, wie nog moet en wie al ruim voldoet.",
  },
  {
    icon: "$gauge",
    color: "accent",
    title: "Persoonlijk overzicht",
    text: "Leden zien zelf direct hun voortgang: hoeveel taken ze al hebben gedaan, en of ze zijn vrijgesteld of hebben afgekocht.",
  },
  {
    icon: "$fileUp",
    color: "primary",
    title: "Ledenimport",
    text: "Zet je ledenbestand in één keer klaar voor het seizoen, rechtstreeks vanuit je bondssoftware.",
  },
  {
    icon: "$barChart",
    color: "accent-blue",
    title: "Rapportages & exports",
    text: "Uren, voortgang en afkoop overzichtelijk te exporteren - handig voor de administratie of ledenvergadering.",
  },
  {
    icon: "$usersRound",
    color: "accent-green",
    title: "Eén account voor het hele gezin",
    text: "Meerdere gezinsleden in de club? Beheer en volg hun taken vanuit één account.",
  },
];
</script>

<template>
  <section id="functies" class="features">
    <VContainer class="landing-container">
      <div v-reveal class="features__header">
        <p class="landing-eyebrow">Functies</p>
        <h2 class="landing-h2">
          Gebouwd op hoe verenigingen vrijwilligers echt inzetten.
        </h2>
      </div>

      <VRow v-reveal>
        <VCol
          v-for="feature in features"
          :key="feature.title"
          cols="12"
          sm="6"
          lg="4"
        >
          <VCard class="feature-card" variant="outlined">
            <div class="feature-card__icon" :class="`bg-${feature.color}`">
              <VIcon :icon="feature.icon" size="22" color="white" />
            </div>
            <h3 class="landing-h3 mt-4 mb-2">{{ feature.title }}</h3>
            <p class="feature-card__text">{{ feature.text }}</p>
          </VCard>
        </VCol>
      </VRow>
    </VContainer>
  </section>
</template>

<style scoped lang="scss">
.features {
  padding: 48px 0;
}

.features__header {
  max-width: 60ch;
  margin-bottom: 32px;
}

.feature-card {
  height: 100%;
  padding: 26px;
  border-radius: 16px;
}

.feature-card__icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-card__text {
  font-size: 14.5px;
  color: rgb(var(--v-theme-emphasis));
  line-height: 1.6;
}
</style>
